/**
 * The FAQs for `/tools/content-calendar-2027`, in their own module so the
 * route's `head` doesn't pull in the page. Rendered on the page and emitted as
 * `FAQPage` JSON-LD from the same list.
 */
export const CONTENT_CALENDAR_FAQS = [
  {
    q: "What is a social media content calendar?",
    a: "A plan of what you will post, where and when, usually a month or a quarter ahead. The useful ones are a spreadsheet: one row per post, with the text, the image, the network and the time. This one starts you with the dates of 2027 worth planning around.",
  },
  {
    q: "How do I use this calendar in Google Sheets?",
    a: "Download the CSV, then in Google Sheets choose File, Import, Upload, and pick the file. Each row is one post: replace the idea in brackets with your own text, add an image link if you have one, and delete the dates you won't use.",
  },
  {
    q: "Can I import the calendar straight into a scheduler?",
    a: "Into PostDaily, yes: the columns are exactly the ones its bulk import reads, so once you've written the posts, one upload turns the sheet into scheduled posts. Run it through the free CSV checker first to catch any row the import would reject.",
  },
  {
    q: "Are the 2027 dates correct?",
    a: "Movable dates are calculated rather than typed in: Easter falls on 28 March 2027, US Mother's Day on 9 May, Father's Day on 20 June and US Thanksgiving on 25 November, which puts Black Friday on the 26th and Cyber Monday on the 29th. Dates that are fixed, like Earth Day on 22 April, are fixed.",
  },
] as const;
